var Account, m;

m = require('mithril');

Account = require('../../state/Account');

module.exports = {
  controller: function(args) {
    var ctrl;
    ctrl = this;
    ctrl.logout = function() {
      return args.loadAccount('public');
    };
    return ctrl;
  },
  view: function(ctrl, args) {
    var name, ref, ref1;
    name = (ref = (ref1 = args.account) != null ? ref1.name : void 0) != null ? ref : '-- not logged in yet --';
    return m('form.AccountInfo', {
      onsubmit: function(e) {
        e.preventDefault();
        return ctrl.logout();
      }
    }, [
      m('h2', 'Current account'), m('p', "Currently logged in as: " + name), name !== 'Public' ? m('input.AccountInfo__button[type=submit]', {
        value: 'Log out'
      }) : void 0
    ]);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9BY2NvdW50SW5mby5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvYXBwL3NyYy91aS9jb21wb25lbnRzL0FjY291bnRJbmZvLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLENBQUEsR0FBSSxPQUFBLENBQVEsU0FBUjs7QUFFSixPQUFBLEdBQVUsT0FBQSxDQUFRLHFCQUFSOztBQUVWLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQ2hCLFVBQUEsRUFBWSxTQUFDLElBQUQ7QUFDWCxRQUFBO0lBQUEsSUFBQSxHQUFPO0lBQ1AsSUFBSSxDQUFDLE1BQUwsR0FBYyxTQUFBO2FBQU0sSUFBSSxDQUFDLFdBQUwsQ0FBaUIsUUFBakI7SUFBTjtXQUNkO0VBSFcsQ0FESTtFQU1oQixJQUFBLEVBQU0sU0FBQyxJQUFELEVBQU8sSUFBUDtBQUNMLFFBQUE7SUFBQSxJQUFBLDhFQUE0QjtXQUM1QixDQUFBLENBQUUsa0JBQUYsRUFBc0I7TUFDckIsUUFBQSxFQUFVLFNBQUMsQ0FBRDtRQUNULENBQUMsQ0FBQyxjQUFGLENBQUE7ZUFDQSxJQUFJLENBQUMsTUFBTCxDQUFBO01BRlMsQ0FEVztLQUF0QixFQUlHO01BQ0YsQ0FBQSxDQUFFLElBQUYsRUFBUSxpQkFBUixDQURFLEVBRUYsQ0FBQSxDQUFFLEdBQUYsRUFBTywwQkFBQSxHQUEyQixJQUFsQyxDQUZFLEVBS0csSUFBQSxLQUFVLFFBRmYsR0FBQSxDQUFBLENBQUUsd0NBQUYsRUFBNEM7UUFDM0MsS0FBQSxFQUFPLFNBRG9DO09BQTVDLENBQUEsR0FBQSxNQUhFO0tBSkg7RUFGSyxDQU5VIn0=
